// Create a context
import React, { createContext, useReducer } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';

async function removeLoginData() {
  try {
    await AsyncStorage.removeItem("login_data");
  } catch (error) {
    // There was an error on the native side
    // You can find out more about this error by using the `error.code` property
    console.log(error.code); // ex: -25300 (errSecItemNotFound)
  };
};

async function getLoginData() {
  try {
    await AsyncStorage.getItem('login_data').then((response) => {
      if (response !== undefined && response !== null) {
        console.log(JSON.parse(response).username)
        return response
      }
    })
  }
  catch (error) {
    console.log(error.code); // ex: -25300 (errSecItemNotFound)
  };
}

async function getApiData() {
  try {
    await AsyncStorage.getItem('client_api').then((rAPI) => {
      console.log(rAPI)
      if (rAPI !== undefined && rAPI !== null) {
        console.log(JSON.parse(rAPI).clientApi)
        return {
          rAPI
        }
      }
    });
  }
  catch (error) {
    console.log(error.code); // ex: -25300 (errSecItemNotFound)
  };
}

export const AuthContext = createContext();

export const authReducer = (state, action) => {
  switch (action.type) {
    case 'LOGIN':
      return {
        user: action.payload,
        username: action.username,
        clientApi: action.clientApi,
        isSigned: true,
        resetPassword: action.payload.resetPassword
      }
    case 'Refresh':
      return {
        user: action.payload,
        username: action.username,
        clientApi: action.clientApi,
        isSigned: true,
        resetPassword: false
      }

    case 'SIGNUP':
      return {
        user: JSON.parse(action.payload.response),
        username: action.username,
        clientApi: action.payload.clientApi,
        isSigned: true,
        resetPassword: action.payload.resetPassword
      }
    case 'LOGOUT':
      removeLoginData();
      return {
        isSigned: false
      }
    default:
      return state
  }
}

export const AuthProvider = ({ children }) => {

  const [state, dispatch] = useReducer(authReducer, {
    user: null,
    username: null,
    clientApi: null,
    isSigned: undefined,
    resetPassword: false
  })

  // To see the change of states, login , logout etc 
  // console.log('AuthContext state: ', state)

  // value ...state is an object in case we add more in the future except of the user variable
  return (
    <AuthContext.Provider value={{ ...state, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
